import { render } from "./BalanceComponent.vue?vue&type=template&id=222df4ba"
import script from "./BalanceComponent.vue?vue&type=script&lang=js"
export * from "./BalanceComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__